module.exports = __webpack_public_path__ + "experience/innovation/images/validate-tablet-screen-1.4b8fa8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/app-experience/Experience/images/validate-tablet-screen-1.png
// module id = 4o7E
// module chunks = 1